module.exports = __webpack_public_path__ + "img/separador.5f32314b.png";